import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { getTranslateByKey } from "@/main/services/utils";

import { SearchClaimProvider, useSearchClaimContext } from "./context";
import FiltersSearchClaim from "./filtersSearchClaim/filtersSearchClaim";
import GridSearchClaim from "./gridSearchClaim/gridSearchClaim";

function SearchClaimScreen() {
	const { dataGrid, formFilters, setDataGrid, getDataSearchClaim, onResetSearch } = useSearchClaimContext();
	const titlePage = `${getTranslateByKey("module.claim")} > ${getTranslateByKey("screen.claimSearchClaims")}`;

	return (
		<ContainerScreen title={titlePage}>
			<FiltersSearchClaim getDataSearchClaim={getDataSearchClaim} onResetSearch={onResetSearch} />
			<GridSearchClaim
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				refreshClaimCounts={() => {}} //call to update status count cards, when it gets made...
			/>
		</ContainerScreen>
	);
}

function WrapperSearchClaimScreen() {
	return (
		<SearchClaimProvider>
			<SearchClaimScreen />
		</SearchClaimProvider>
	);
}

export default withQueryparams(WrapperSearchClaimScreen);
